var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorExclamation = function SvgErrorExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 81 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DE0B0B",
    d: "M56.19 7.643a3.33 3.33 0 0 0-2.357-.976H27.166c-.884 0-1.732.351-2.357.976L8.143 24.31a3.33 3.33 0 0 0-.977 2.357v26.666c0 .887.35 1.733.977 2.357l16.666 16.667a3.33 3.33 0 0 0 2.357.976h26.667c.886 0 1.733-.35 2.356-.977L72.856 55.69a3.33 3.33 0 0 0 .977-2.357V26.667c0-.885-.352-1.732-.977-2.357zM43.832 56.667h-6.667V50h6.667zm0-13.334h-6.667v-20h6.667z"
  })));
};
export default SvgErrorExclamation;